import __var_0__ from '@stdlib/math/base/assert/is-nan';
import __var_1__ from '@stdlib/math/base/special/abs';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isnan = __var_0__;
var abs = __var_1__;


// MAIN //

/**
* Computes the minimum absolute value of a strided array, ignoring `NaN` values.
*
* @param {PositiveInteger} N - number of indexed elements
* @param {NumericArray} x - input array
* @param {integer} stride - stride length
* @param {NonNegativeInteger} offset - starting index
* @returns {number} minimum absolute value
*
* @example
* var floor = require( '@stdlib/math/base/special/floor' );
*
* var x = [ 2.0, 1.0, 2.0, -2.0, -2.0, 2.0, 3.0, 4.0, NaN, NaN ];
* var N = floor( x.length / 2 );
*
* var v = nanminabs( N, x, 2, 1 );
* // returns 1.0
*/
function nanminabs( N, x, stride, offset ) {
	var min;
	var ix;
	var v;
	var i;

	if ( N <= 0 ) {
		return NaN;
	}
	if ( N === 1 || stride === 0 ) {
		return x[ offset ];
	}
	ix = offset;
	for ( i = 0; i < N; i++ ) {
		v = x[ ix ];
		if ( v === v ) {
			break;
		}
		ix += stride;
	}
	if ( i === N ) {
		return NaN;
	}
	min = abs( v );
	i += 1;
	for ( i; i < N; i++ ) {
		ix += stride;
		v = abs( x[ ix ] );
		if ( isnan( v ) ) {
			continue;
		}
		if ( v < min ) {
			min = v;
		}
	}
	return min;
}


// EXPORTS //
export default nanminabs;
